import { ProfileDto } from '@diritto/common/account/dtos/profile.dto';
import { JsonLd } from 'app-components/common/JsonLd';
import { useMemo } from 'react';
import { configure } from 'utils/configure';
import { generateImageUrl } from 'utils/generateImageUrl';
import { getFullUrl } from 'utils/url';

export const ProfileJsonLd = ({ profile }: { profile?: ProfileDto }) => {
  const openImageUrl = useMemo(
    () =>
      profile?.profileImage
        ? generateImageUrl({
            path: profile.profileImage.path,
            isPrivate: profile.profileImage.isPrivate,
          })
        : `${configure.staticPrefix}/images/og/diritto-og.png?v=2`,
    [profile],
  );
  const title = profile?.nickname;
  const url = useMemo(() => getFullUrl(`/accounts/profiles/${profile?.id}`), [profile?.id]);

  if (!profile) {
    return null;
  }

  return (
    <JsonLd
      data={{
        '@context': 'http://schema.org',
        '@type': 'NewsArticle',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://google.com/article',
        },
        headline: title,
        image: [openImageUrl],
        url,
        description: profile.description,
        author: {
          '@type': 'Person',
          name: profile.nickname,
          url,
        },
      }}
    />
  );
};
